var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fader"},[_c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.contentVisible)?_vm._t("default"):_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }